export const funderGroup = () => {
  //find .wp-block-funding-dropdown select
  const fundingCats = document.querySelectorAll('.wp-block-funding-dropdown select');

  //find .funder-group with id matching select value and add class .active
  fundingCats.forEach((cat) => {
    cat.addEventListener('change', () => {
      const catValue = (cat as HTMLSelectElement).value;
      const fundingGroups = document.querySelectorAll('.funder-group');

      fundingGroups.forEach((group) => {
        if (group.id === catValue) {
          group.classList.add('active');
        } else {
          group.classList.remove('active');
        }
      });
    });
  });
};
